<template>
  <div class="absolute right-0 w-full z-50">
    <alert :key="id" v-for="(alert, id) in allAlerts" :type="alert.type" :message="alert.message" :full-alert="alert" />
  </div>
</template>

<script>
import Alert from "@/components/Alerts/Alert";
export default {
  name: "AlertList",
  components: {Alert},
  computed: {
    allAlerts() {
      return this.$store.getters.getAlerts
    }
  }
}
</script>

<style scoped>

</style>